import styles from '../../Help.module.scss';

import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 4 Image.png';
import step3Img1 from './Step 5 Image 1.png';
import step3Img2 from './Step 5 Image 2.png';
import step4Img from './Step 6 Image.png';
import step5Img from './Step 7 Image.png';
import step6Img from './Step 8 Image.png';
import step7Img from './Step 9 Image.png';
import step8Img from './Step 10 Image.png';

// Header
const headerText = `Renewing Your Registration Number`;
const subtitleText = `For those of you who are new to our system, but not new to Chicago’s house sharing program,
                    this portal serves as your point of reference for all of your proper documentation needed to
                    continue to utilize this program. Our renewal process guide will walk you through how to
                    connect your previous information to your new account as well as how to complete the renewal
                    process in our new system.`;

// Steps
const step1Text = (
  <p>
    When you are due for renewal, you will receive communication with the
    instructions on how to submit the renewal application. First, navigate to
    the ”My Registration Numbers” section of your Account Dashboard.
  </p>
);
const step2Text = (
  <p>
    Under “My Registration Numbers”, click “Request Renewal” under the Actions
    Required column.
  </p>
);
// Since this has two images, we will directly pass the img tags
const step3Text = (
  <>
    <p>
      If you have specified “Yes” to the question of Primary Residency on your
      previous registration with the third-party intermediary, you must upload
      “Proof of Primary Residency” using any of the documentation options
      available. This documentation must be current/unexpired and legible. The
      file size of this document must be greater than 1 KB and less than 5 MB.
    </p>
    <p>Answer any additional questions about your renewal to proceed forward</p>
    <div className='text-center'>
      <img
        className={`img-fluid ${styles.howToImg}`}
        src={step3Img1}
        alt='Step 3 Image 1'
      ></img>
    </div>
    <br />
    <p>
      Those who have not specified “Yes” to Primary Residency will see this
      screen:
    </p>
    <br />
    <div className='text-center'>
      <img
        className={`img-fluid ${styles.howToImg}`}
        src={step3Img2}
        alt='Step 3 Image 2'
      ></img>
    </div>
  </>
);
const step4Text = (
  <p>Once your upload is successfully complete, you will see this message:</p>
);
const step5Text = (
  <p>
    To verify that this step is complete, go back to your Account Dashboard. You
    will see your updated information appear under “My Registrations” with the
    status of “Approved/Renewal Under Review.” BACP will contact you via email
    once this process is complete.
  </p>
);
const step6Text = (
  <p>
    Once your registration gets approved, you will be required to pay a $125
    fee, which you can also do through the portal. The status of your
    registration will change to “Approved - Payment Required” and you will see
    the “Add to Cart” button appear to the right.
  </p>
);
const step7Text = (
  <p>
    Once the registration(s) has been added to your cart, click on “Checkout
    with eCheckout.”
  </p>
);
const step8Text = (
  <p>
    Once you have completed payment, you will see the status simply say
    “Approved” and the expiration date will update. That means the process is
    complete and no further action is needed.
  </p>
);

const RenewYourRegistrationNumber = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} />
      <HowToStep stepNumber={4} content={step4Text} imgSrc={step4Img} />
      <HowToStep stepNumber={5} content={step5Text} imgSrc={step5Img} />
      <HowToStep stepNumber={6} content={step6Text} imgSrc={step6Img} />
      <HowToStep stepNumber={7} content={step7Text} imgSrc={step7Img} />
      <HowToStep stepNumber={8} content={step8Text} imgSrc={step8Img} />
    </>
  );
};

export default RenewYourRegistrationNumber;
